"use client";

/**
 * FooterSchedule.tsx
 *
 * Second column of the footer.
 * Shows the restaurant's opening hours schedule.
 */

import React from "react";

interface ScheduleItem {
  days: string;
  time: string;
}

interface FooterScheduleProps {
  title: string;
  schedule: ScheduleItem[];
}

const FooterSchedule = ({ title, schedule }: FooterScheduleProps) => {
  return (
    <div className="flex flex-col space-y-10">
      <h4 className="font-cormorant text-2xl font-bold uppercase tracking-widest text-white after:content-[''] after:block after:w-10 after:h-0.5 after:bg-[#c59d5f] after:mt-4">
        {title}
      </h4>
      <ul className="space-y-4 font-light">
        {schedule.map((item, index) => (
          <li key={index} className="flex justify-between text-sm group">
            <span className="text-gray-400 group-hover:text-white transition-colors">
              {item.days || "Unavailable"}
            </span>
            <span className="text-white font-medium">
              {item.time || "Closed"}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterSchedule;
